<template>
    <div
        class="border-2 bg-white flex flex-col"
        :class="borderClasses"
    >
        <div
            class="text-center text-black"
        >
            <h2
                :class="titleClasses"
            >
                <slot name="title"></slot>
            </h2>
        </div>
        <div class="prize-image mt-auto">
            <slot name="images"></slot>
        </div>
        <div
            class="prize-info mt-auto bg-gray-100 p-2"
        >
            <slot></slot>
        </div>

    </div>
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            default: '',
        }
    },
    computed: {
        borderClasses () {
            if (this.type === 'grandPrize') {
                return 'border-red-600'
            }
            // basic
            return 'border-black'
        },
        titleClasses () {
            if (this.type === 'runnerUp') {
                return 'font-extrabold text-4xl bg-black text-white py-2';
            }
            if (this.type === 'grandPrize') {
                return 'font-extrabold text-4xl bg-red-600 text-white py-2'
            }
            // basic
            return 'font-light text-xl text-black py-4';
        },
    }
}
</script>